import { createExternalApi } from './apiFactory'

export const driverSchedulingApi = createExternalApi({
  serviceName: 'driver-scheduling',
  authHeaderName: 'Access-Token',
  authHeaderValuePrefix: '',
})
